import React, {
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';

import { Session, User } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';

interface AuthContextType {
  user: User | null;
  session: Session | null;

  isLoggedIn: boolean;

  signUp: (email: string, password: string) => Promise<any>;
  signIn: (email: string, password: string) => Promise<any>;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType>(
  {} as AuthContextType
);

export const AuthProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {

  const [user, setUser] = useState<User | null>(null);

  const [session, setSession] =
    useState<Session | null>(null);

  useEffect(() => {

    // 🔥 current session
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setUser(data.session?.user ?? null);
    });

    // 🔥 auth listener
    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        setUser(session?.user ?? null);
      }
    );

    return () => {
      subscription.unsubscribe();
    };

  }, []);

  // 🔥 signup
  const signUp = async (
    email: string,
    password: string
  ) => {

    return await supabase.auth.signUp({
      email,
      password
    });

  };

  // 🔥 login
  const signIn = async (
    email: string,
    password: string
  ) => {

    return await supabase.auth.signInWithPassword({
      email,
      password
    });

  };

  // 🔥 logout
  const logout = async () => {

    await supabase.auth.signOut();

  };

  return (
    <AuthContext.Provider
      value={{
        user,
        session,

        isLoggedIn: !!user,

        signUp,
        signIn,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);